import type { ShowImeiActionDetails } from '@backmarket/http-api/src/api-specs-help-center/diagnosis/types/common'

import type { MachineContext } from '../Diagnosis.machine.types'

export const getIMEI = (issueAction: MachineContext['issueAction']) => {
  const issueActionDetails = issueAction?.details as ShowImeiActionDetails

  return issueActionDetails?.imei
}
